declare const require: any;
import { Injectable } from '@angular/core'
const StoryblokClient = require('storyblok-js-client')

@Injectable({
  providedIn: 'root'
})
export class StoryblokService {
  private sbClient = new StoryblokClient({
    accessToken: 'c6LkJk4A9yDwqTX1T9zo1gtt'
  })

  constructor() { }

  getStory(slug: string, params?: object): Promise<any> {
    return this.sbClient.getStory(slug, params)
      .then(res => res.data);
  }

  getStories(params?: object): Promise<any> {
    return this.sbClient.getStories(params)
      .then(res => res.data);
  }
}
